import clsx from "clsx"

import styles from "./ListItemStack.module.scss"
import { ListItemStackProps } from "./ListItemStack.types"

export default function ListItemStack(props: ListItemStackProps) {
    const { children, className } = props

    return <div className={clsx(styles.base, className)}>{children}</div>
}
